<template>
  <div
    class="component-left-container-1 card-background"
    style="height: calc(100% - 60% - 12px)"
  >
    <el-card style="height: 100%">
      <div slot="header" class="clearfix">
        <div class="header flex items-center justify-center">
          <!-- <i
            class="el-icon-video-camera-solid"
            style="font-size: 26px; color: #4bace0"
          ></i>
          <div class="font-bold ml-2" style="font-size: 26px">
            {{ data && data.name }}
          </div> -->

          <div class="cc-header flex justify-around items-center p-0">
            <dv-decoration-1 style="width: 100px; height: 20px" />
            <div class="font-bold" style="font-size: 26px">
              <!-- {{ data && data.name }} -->
              健康互动
            </div>
            <dv-decoration-1 style="width: 100px; height: 20px" />
          </div>
        </div>
      </div>
      <div id="word-cloud" style="height: 300px"></div>
    </el-card>
    <NoticeDialog :show.sync="visible" :detail="detail"></NoticeDialog>
  </div>
</template>
<script>
import * as echarts from "echarts";
import "echarts-wordcloud";
import NoticeDialog from "../../Components/NoticeDialog.vue";

export default {
  data() {
    return {
      visible: false,
      detail: {},
    };
  },
  components: {
    NoticeDialog,
  },
  watch: {
    data: {
      handler(n) {
        this.$nextTick(() => {
          // this.initChart();
        });
      },
    },
  },
  props: {
    data: Object,
    default: () => {},
  },
  mounted() {
    setTimeout(() => {
      this.initChart();
    }, 2000);
  },
  methods: {
    async initChart() {
      var myChart = echarts.init(document.getElementById("word-cloud"));
      let option = await this.initWordCloudy();
      myChart.setOption(option);
      myChart.on("click", (param) => {
        console.log(param);
        this.detail = param.data.detail;
        this.visible = true;
      });
    },

    async initWordCloudy() {
      let titleData = this.data.list.map((v) => {
        return {
          name: v.title,
          value: Math.floor(Math.random() * (100 - 1 + 1)) + 1,
          detail: v,
        };
      });
      let colorList = [
        "#ff9597",
        "#22cfe0",
        "#b9b1f0",
        "#51b7fb",
        "#76e68f",
        "#fa8b54",
        "#ffc545",
        "#ffd9a6",
      ];
      let option = {
        tooltip: {
          show: true,
        },
        series: [
          {
            type: "wordCloud", //词云图
            left: "0%", // X轴偏移量
            top: "0%", // Y轴偏移量
            width: "100%", // canvas宽度大小
            height: "100%", // canvas高度大小
            sizeRange: [12, 30], //  词典字体大小范围配置
            rotationRange: [0, 0], // 词典字体旋转角度配置，默认不旋转
            gridSize: 12, // 词典字体间距配置
            layoutAnimation: true, // 为false词典过度会阻塞
            textStyle: {
              fontFamily: "sans-serif",
              fontWeight: "bold",
              // Color可以是一个回调函数或一个颜色字符串
              color: function () {
                let index = Math.floor(Math.random() * colorList.length);
                return colorList[index];
              },
            },

            emphasis: {
              focus: "self",

              textStyle: {},
            },
            // color: ["#f00", "#0f0", "#00f"],
            layoutAnimation: true,
            data: titleData,
          },
        ],
      };
      return option;
    },
  },
};
</script>
<style scoped lang="less">
::v-deep {
  .el-card {
    background-color: transparent !important;
  }
  .row-item {
    border-bottom: 1px solid @border-color !important;
  }
  .el-table,
  .el-table__expanded-cell {
    background: none;
  }
}
</style>
